var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHumidity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    opacity: 0.7,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 132.9 135.7",
    style: {
      enableBackground: "new 0 0 132.9 135.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.5,121.7C20.3,121.4,2.9,98.4,9.6,74c5.9-21.4,19-38.6,32.5-55.6c2.8-3.5,4.9-3.7,7.8-0.1 c13.4,17,26.6,34.2,32.5,55.6C89.3,98.8,71.2,122.1,45.5,121.7z M46.1,72.4c7.5,0,17.3,0.9,20.9-4.8c3.4-5.4-3.8-12.5-7.3-18.5 c-13.6-23.4-13.8-23.5-27.5,0.1c-3.4,5.9-10.8,13-7.2,18.5C28.8,73.3,38.6,72.4,46.1,72.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M110.3,23c-2.6,0-5.2-0.1-7.7,0c-2.8,0.1-4.9-0.2-4.9-4c-0.1-3.9,1.3-5.2,5.1-5c5.5,0.2,11.1,0.1,16.6,0 c3.3-0.1,5.5,0.2,5.5,4.6c0,4.5-2.5,4.5-5.6,4.4C116.2,22.9,113.2,23,110.3,23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M110.2,71.7c-2.6,0-5.2-0.1-7.7,0c-2.8,0.1-4.9-0.2-4.9-4c-0.1-3.9,1.3-5.2,5.1-5c5.5,0.2,11.1,0.1,16.6,0 c3.3-0.1,5.5,0.2,5.5,4.6c0,4.5-2.5,4.5-5.6,4.4C116.1,71.6,113.1,71.7,110.2,71.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M110.2,121.6c-2.6,0-5.2-0.1-7.7,0c-2.8,0.1-4.9-0.2-4.9-4c-0.1-3.9,1.3-5.2,5.1-5c5.5,0.2,11.1,0.1,16.6,0 c3.3-0.1,5.5,0.2,5.5,4.6c0,4.5-2.5,4.5-5.6,4.4C116.1,121.6,113.1,121.6,110.2,121.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M113.8,103.5c-1.9,0-3.8,0-5.6,0c-2.1,0.1-3.5-0.2-3.6-2.9c-0.1-2.8,0.9-3.8,3.7-3.7c4,0.2,8.1,0.1,12.1,0 c2.4,0,4,0.1,4,3.3c0,3.3-1.8,3.3-4.1,3.2C118.1,103.5,115.9,103.5,113.8,103.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M113.8,53.8c-1.9,0-3.8,0-5.6,0c-2.1,0.1-3.5-0.2-3.6-2.9c-0.1-2.8,0.9-3.8,3.7-3.7c4,0.2,8.1,0.1,12.1,0 c2.4,0,4,0.1,4,3.3c0,3.3-1.8,3.3-4.1,3.2C118.1,53.8,115.9,53.8,113.8,53.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M113.8,87.9c-1.9,0-3.8,0-5.6,0c-2.1,0.1-3.5-0.2-3.6-2.9c-0.1-2.8,0.9-3.8,3.7-3.7c4,0.2,8.1,0.1,12.1,0 c2.4,0,4,0.1,4,3.3c0,3.3-1.8,3.3-4.1,3.2C118.1,87.8,115.9,87.9,113.8,87.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M113.8,38.4c-1.9,0-3.8,0-5.6,0c-2.1,0.1-3.5-0.2-3.6-2.9c-0.1-2.8,0.9-3.8,3.7-3.7c4,0.2,8.1,0.1,12.1,0 c2.4,0,4,0.1,4,3.3c0,3.3-1.8,3.3-4.1,3.2C118.1,38.4,115.9,38.4,113.8,38.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumidity);
export default __webpack_public_path__ + "static/media/humidity.d49e9f30f5ed097d7ecdbfb6f2744835.svg";
export { ForwardRef as ReactComponent };